export default "__VITE_ASSET__43aa6188__"